import App from '@/App';
import '@/index.css';
import reportWebVitals from '@/reportWebVitals';
import { EnvironmentService } from '@/services/environment';
import { SentryService } from '@/services/sentry';
import { setupDayjsExtensions } from '@/utils/setupDayjsExtensions';
import { Big } from 'big.js';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';

EnvironmentService.init();
SentryService.init();

Big.RM = 2;
Big.DP = 10;

setupDayjsExtensions();

// eslint-disable-next-line react/no-deprecated, @typescript-eslint/no-deprecated
ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
